import ContentfulModuleHeader from "./ContentfulModuleHeader"
import ContentfulModuleProjectSection from "./ContentfulModuleProjectSection"
import ContentfulModuleServiceSection from "./ContentfulModuleServiceSection"
import ContentfulModuleArticle from "./ContentfulModuleArticle"

export default {
  ContentfulModuleHeader,
  ContentfulModuleProjectSection,
  ContentfulModuleServiceSection,
  ContentfulModuleArticle,
}